var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ADADAD",
    strokeWidth: 1.5,
    d: "M3.333 11.5c0-1.4 0-2.1.273-2.635a2.5 2.5 0 0 1 1.092-1.093C5.233 7.5 5.933 7.5 7.333 7.5h5.334c1.4 0 2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093c.273.535.273 1.235.273 2.635 0 2.1 0 3.15-.41 3.953a3.75 3.75 0 0 1-1.638 1.638c-.802.409-1.852.409-3.952.409H9.333c-2.1 0-3.15 0-3.952-.409a3.75 3.75 0 0 1-1.639-1.639c-.409-.802-.409-1.852-.409-3.952Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M13.333 6.667v-.834a3.333 3.333 0 0 0-6.666 0v.834"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12.5,
    r: 1.667,
    fill: "#ADADAD"
  })));
};
export default SvgLock;